angular.module('bribac.decorator.uibDatePicker', [
    'bribac.service.datePickerService',
    'ui.bootstrap'
  ]).config(datePickerDecorator)

  function datePickerDecorator($provide){
    $provide.decorator('uibDatepickerDirective', ['$delegate', 'datePickerService', function($delegate, datePickerService) {
        var directive = $delegate[0];

        var link = directive.link;

        directive.compile = function() {
            return function(scope, element, attrs, ctrls) {
                link.apply(this, arguments);

                var datepickerCtrl = ctrls[0];
                var ngModelCtrl = ctrls[1];

                scope.$watch(function() {
                    return datepickerCtrl.activeDate;
                }, function(newValue, oldValue) {
                    if (oldValue.getMonth() !== newValue.getMonth()
                       || oldValue.getYear() !== newValue.getYear()) {
                        datePickerService.monthChanged(newValue);
                    }
                }, true);

                /*
                Refresh date picker by calling datepicker controller 'refreshView' method
                @link https://github.com/angular-ui/bootstrap/issues/779
                */

                if (ngModelCtrl) {
                    // Listen for 'refreshDatepickers' event...
                    scope.$on('refreshDatepicker', function refreshView() {
                        datepickerCtrl.refreshView();
                    });
                }
            }
        };
        return $delegate;
    }]);
}